import {
  Banner,
  Form,
  FormGroup,
  Label,
  Msg,
  Select,
} from "@shared/components";
import { useGetApplicantSegmentExperienceEnums } from "@shared/hooks/query";
import MSG from "@shared/services/message";

interface ApplicantSegmentSurveyFormProps {
  formValues?: {};
  onFormChange?: (formValid: boolean, formValues: {}, formErrors?: {}) => void;
  showErrors?: boolean;
}

export function ApplicantSegmentSurveyForm({
  formValues,
  onFormChange,
  showErrors,
}: ApplicantSegmentSurveyFormProps) {
  const { data: applicantSegmentExperience } =
    useGetApplicantSegmentExperienceEnums();

  return (
    <div className="code-editor-exam-detail__survey">
      <div className="code-editor-exam-detail__survey__title">
        <h2>
          <Msg id="exam.survey" />
        </h2>
        <Banner
          type="info"
          transparent={true}
          className="code-editor-exam-detail__survey__title-info-banner"
        >
          <Msg className="text-xs" id="exam.survey.titleInfo" />
        </Banner>
      </div>
      <Form
        validation={{ applicantExperience: ["required"] }}
        showAllErrors={showErrors}
        onFormChange={onFormChange}
        initialValues={formValues}
      >
        <FormGroup>
          <Label
            className="text-md"
            title={<Msg id="form.workExperience.label" />}
          />
          <Msg id="form.workExperience.description" tagName="p" />
          {applicantSegmentExperience && (
            <Select
              name="applicantExperience"
              options={[
                {
                  value: "",
                  label: MSG.getMessageByKey("custom-form-select.placeholder"),
                },
                ...applicantSegmentExperience.map((item) => ({
                  value: item.value,
                  label: item.displayString,
                })),
              ]}
            />
          )}
        </FormGroup>
      </Form>
    </div>
  );
}
